var map = {
	"./AI.png": "c4e8",
	"./arrowTop.png": "85d4",
	"./arrowUp.png": "ad96",
	"./back.png": "1faf",
	"./backti.png": "2fa6",
	"./chat.png": "84f6",
	"./close.png": "04b3",
	"./coverBg.png": "c9c3",
	"./defaultNew.png": "453d",
	"./empty.png": "b45c",
	"./goodComment.png": "06c1",
	"./headerBg.png": "c531",
	"./hot.png": "60b1",
	"./introduce.png": "e7b3",
	"./leftStr.png": "e561",
	"./like.png": "ef74",
	"./openTime.png": "e251",
	"./phone.png": "9347",
	"./play.png": "d99c",
	"./position.png": "b9f8",
	"./recom.png": "bad0",
	"./reload.png": "7b3d",
	"./rightStr.png": "b737",
	"./robot/aavatar.png": "bfb0",
	"./robot/chatbg.png": "d452",
	"./robot/children.png": "1a6f",
	"./robot/cover.png": "f2da",
	"./robot/qavatar.png": "9407",
	"./send.png": "fbe7",
	"./star.png": "ba5a",
	"./starci.png": "7172",
	"./stop.png": "bf2e",
	"./time.png": "e1fe",
	"./tiny.png": "d006",
	"./tinyic.png": "e6bc",
	"./traffic.png": "9d46",
	"./xiaofeng.png": "7498"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";